import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Token } from '@angular/compiler/src/ml_parser/lexer';
import { Injectable } from '@angular/core';
import { api, apiPanel, environment } from 'environments/environment';
import {Observable, ObservedValueOf} from 'rxjs';
import { Ciudad } from './models/ciudad-model';
import { Contacto } from './models/contacto-model';
import { Login } from './models/login-model';
import { Parametro } from './models/parametro-model';
import { Propiedad } from './models/propiedad-model';
import { PropiedadLista } from './models/propiedadLista-model';
import { RecuperarPassword } from './models/recuperarPassword-model';
import { Reserva } from './models/reserva-model';
import { ResetPassword } from './models/resetPassword-model';
import { TipoPropiedad } from './models/tipopropiedad-model';
import { UserModel } from './models/user-model';
import { Usuario } from './models/usuario-model';
import CryptoJS from 'crypto-js';
import { Barrio } from './models/barrio-model';
import { Paquete } from './models/paquete-model';
import { Grupo } from './models/grupo-model';
import { SDTCotizacion } from './models/cotizacion-model';

@Injectable({
    providedIn: 'root'
})

export class Services {
    URL:string = api+'api/';
    URLToken:string = api+'token';
    OnlyURL:string = api;
	constructor(private http: HttpClient) {}

    getToken(form:Login):Observable<Token> {
        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        let body = 'grant_type='+form.grant_type+'&userName='+form.username+'&password='+form.password;
        return this.http.post<Token>(this.URLToken, body, options);
    }

    getBearerToken(){
        return localStorage.getItem("access_token");
    }

    enviarMensaje(form:Contacto):Observable<any>{
        let direccion = this.URL+'consultaviajes';
        return this.http.post<any>(direccion, form);
    }

    getParametro(nombre: string):Observable<Parametro>{
        let direccion = this.URL+'parametro/'+nombre;
        return this.http.get<Parametro>(direccion);
    }

    getPaquetes():Observable<Array<Paquete>>{
        let direccion = this.URL+'paquete';
        return this.http.get<Array<Paquete>>(direccion);
    }

    getGrupos():Observable<Array<Grupo>>{
        let direccion = this.URL+'paquete/grupos';
        return this.http.get<Array<Grupo>>(direccion);
    }

    getPaquetesDestacados():Observable<Array<Paquete>>{
        let direccion = this.URL+'paquete/destacados';
        return this.http.get<Array<Paquete>>(direccion);
    }

    getPaquete(id: number):Observable<Paquete>{
        let direccion = this.URL+'paquete/'+id.toString();
        return this.http.get<Paquete>(direccion);
    }

    getCotizacion(codigo: string):Observable<SDTCotizacion>{
        let direccion = apiPanel+'GetCotizacion';
        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        }
        let body = {
            Codigo: codigo
        }
        let json = JSON.stringify(body);
        return this.http.post<SDTCotizacion>(direccion, json, options);
    }

    registrarVisita(codigo: string, ip: string, navegador: string):any{
        let direccion = apiPanel+'RegistrarVisita';
        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        }
        let body = {
            Codigo: codigo,
            IP: ip,
            Navegador: navegador
        }
        let json = JSON.stringify(body);
        return this.http.post<any>(direccion, json, options);
    }

    getIP():any{
        let direccion = 'https://api.ipify.org?format=json';
        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        }
        return this.http.get<any>(direccion, options);
    }

    encode(string: string) {
        let key: string = "mikey";
        // key encoding 
        //const keyHex = CryptoJS.enc.Utf8.parse(key);
        const keyHex = btoa("Administrador");
        console.log(keyHex);
        // encryption
        const passwordDES = CryptoJS.DES.encrypt(string, keyHex, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }).toString();
        console.log(passwordDES);
        return passwordDES;
    }
}